import React from 'react';
import styled from 'styled-components';
import { Box, Flex, Hr, Text, Image } from 'core/ui/atoms';
import { NavigationHeader } from 'onramp/ui/components';
import { LoaderGif } from 'core/assets/images/V2';

const PaymentProcessing = () => {
  return (
    <Box>
      <NavigationHeader
        title="Payment Processing"
        showNavigation={false}
      />
      <Hr />
      <BodyContainer direction='column' justifyContent='center' alignItems='center'>
        <LoadingImage src={LoaderGif} alt='loading' />
        <Title>Authorizing...</Title>
        <Subtitle>After your payment is done, you will see your order confirmation.</Subtitle>
      </BodyContainer>
    </Box>
  );
};

const Title = styled(Text)`
  color: #36443A;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0px;
`;

const Subtitle = styled(Text)`
  margin-top: 8px;
  text-align: center;
  color: #36443A;
  text-align: center;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin: 0px;
  width: 70%;
`;

const BodyContainer = styled(Flex)`
  width: 100%;
  height: calc(70vh);
`;

const LoadingImage = styled(Image)`
  height: 94px;
  width: 94px;
  object-fit: cover;
`;

export default PaymentProcessing;
